module.exports = __webpack_public_path__ + "static/media/searchIcon.604c7687.svg";